const R = require('ramda')
const globalColors = require('@vimcar/shared-utils/styles/colors')

const appColors = {
  colorResetPassword: '#616161',
}

module.exports = R.merge(globalColors, appColors)
